function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.6,25.71,21.85,20l5.73-5.76a1.3,1.3,0,0,0,.39-1,1.21,1.21,0,0,0-.39-.89,1.27,1.27,0,0,0-1-.39,1.25,1.25,0,0,0-.89.39L20,18.1l-5.76-5.76a1.41,1.41,0,0,0-1-.39,1.25,1.25,0,0,0-.89.39,1.32,1.32,0,0,0-.39,1,1.24,1.24,0,0,0,.39.88L18.13,20l-5.74,5.76a1.31,1.31,0,0,0-.39,1,1.25,1.25,0,0,0,.39.89,1.33,1.33,0,0,0,1.85,0L20,21.8l5.76,5.76a1.29,1.29,0,0,0,1.85,0,1.35,1.35,0,0,0,.39-1A1.23,1.23,0,0,0,27.6,25.71Z"
});

var SvgIconClose = function SvgIconClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return _ref2;
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-close.51eaef44.svg";
export { ForwardRef as ReactComponent };